import { Typography } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';
import { TableCellType } from '../../ComparisonTableTypes';
import styles from './TableMobileCell.module.scss';

export interface TableMobileCellProps extends TableCellType {
  cellTitle: TableCellType;
  className?: string;
}

export const TableMobileCell: React.FC<TableMobileCellProps> = (props) => {
  return (
    <div className={classNames(styles.table_mobile_cell, props.className)}>
      {props.cellTitle.image ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={props.cellTitle.image.imageUrl}
          alt={props.cellTitle.image.altText}
          className={styles.header_image}
          loading="lazy"
          fetchPriority="low"
          decoding="async"
        />
      ) : (
        <Typography as="p" className={styles.title}>
          {props.cellTitle.bodyText}
        </Typography>
      )}
      <div className={styles.cell_content}>
        {props.image ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={props.image.imageUrl}
            alt={props.image.altText}
            className={styles.standard_image}
            loading="lazy"
            fetchPriority="low"
            decoding="async"
          />
        ) : (
          <div
            className={styles.content_text}
            dangerouslySetInnerHTML={{ __html: props.bodyText || '' }}
          />
        )}
        {props.helperText ? (
          <div
            dangerouslySetInnerHTML={{ __html: props.helperText || '' }}
            className={styles.helper_text}
          />
        ) : (
          <span className={styles.helper_text_placeholder} aria-hidden="true" />
        )}
      </div>
    </div>
  );
};
